import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";
import { Region as Region_1, NewRegion } from "./Shared/SharedModels.jsx";
import { Spinner, Text as Text$, CardHeader, Card, Caption1, Title3, Body1, Body1Strong, tokens, DialogSurface, DialogBody, DialogActions, Switch, Input, Field, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { equals, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { DismissFilled, CheckmarkFilled, PenDismissRegular, WarningFilled, DeleteRegular, SaveRegular, EditRegular, DismissRegular, AddRegular } from "@fluentui/react-icons";
import { take, length, tryHead, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { toastServerError, Region } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { map, append as append_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { some } from "./fable_modules/fable-library-js.4.24.0/Option.js";

function AddRegionDialog(addRegionDialogInputProps) {
    let elems_4, el_4, el_2, el, props_43, props_41, el_6, el_18, elems_2, el_11, el_16, matchValue_1, el_13, el_28, elems_3, el_22, el_20, el_26, el_24, name, name_2, elemsToUse;
    const setRegions = addRegionDialogInputProps.setRegions;
    const regions = addRegionDialogInputProps.regions;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    let patternInput_3;
    const initial_2 = new NewRegion("", true);
    patternInput_3 = reactApi.useState(initial_2);
    const setForm = patternInput_3[1];
    const form = patternInput_3[0];
    const resetForm = () => {
        setForm(new NewRegion("", true));
    };
    const el_30 = Dialog;
    return createElement(el_30, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_4 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            iconPosition: "before",
            appearance: "primary",
            children: "Legg til",
        })),
    })), (props_43 = singleton_1((props_41 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til region",
    })), (el_18 = DialogContent, createElement(el_18, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_2 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_1[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_1, value_1_8) => {
                const v = value_1_8;
                setForm(new NewRegion(v.value, form.Enabled));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    }))))))))), (el_16 = Field, createElement(el_16, {
        label: "Aktiv",
        children: (matchValue_1 = tryHead([(el_13 = Switch, createElement(el_13, {
            checked: form.Enabled,
            onChange: (_arg_2, value_1_11) => {
                setForm(new NewRegion(form.Name, value_1_11.checked));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_28 = DialogActions, createElement(el_28, createObj(ofArray([["position", "end"], (elems_3 = [(el_22 = Button, createElement(el_22, {
        icon: (el_20 = DismissRegular, createElement(el_20, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_3) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_26 = Button, createElement(el_26, {
        icon: (el_24 = AddRegular, createElement(el_24, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_4) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Region.AddRegion(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    errorToast(setCtx, "addRegionConflict", "Kunne ikke legge til region", "Det finnes allerede en region med dette navnet", undefined);
                }
                else {
                    const r = res.fields[0];
                    setRegions(append_1([r], regions));
                    successToast(setCtx, `addRegion${r.Id}Success`, "Suksess", `${r.Name} ble lagt til`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_41)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_43)),
    })))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditRegionDialog(editRegionDialogInputProps) {
    let elems_5, el_4, el_2, el, props_44, props_42, el_6, el_18, elems_3, elems_1, el_11, el_16, matchValue_1, el_13, el_28, elems_4, el_22, el_20, el_26, el_24, name_2, name_4, elemsToUse;
    const setRegions = editRegionDialogInputProps.setRegions;
    const regions = editRegionDialogInputProps.regions;
    const regionToEdit = editRegionDialogInputProps.regionToEdit;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(regionToEdit);
    const setForm = patternInput_2[1];
    const form = patternInput_2[0];
    const dependencies = [regionToEdit];
    reactApi.useEffect(() => {
        setForm(regionToEdit);
    }, dependencies);
    const el_30 = Dialog;
    return createElement(el_30, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_44 = singleton_1((props_42 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger region",
    })), (el_18 = DialogContent, createElement(el_18, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(isNullOrWhiteSpace(form.Name) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_2, value_1_7) => {
                setForm(new Region_1(form.Id, value_1_7.value, form.Enabled));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_16 = Field, createElement(el_16, {
        label: "Aktiv",
        children: (matchValue_1 = tryHead([(el_13 = Switch, createElement(el_13, {
            checked: form.Enabled,
            onChange: (_arg_3, value_1_10) => {
                setForm(new Region_1(form.Id, form.Name, value_1_10.checked));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_28 = DialogActions, createElement(el_28, createObj(ofArray([["position", "end"], (elems_4 = [(el_22 = Button, createElement(el_22, {
        icon: (el_20 = DismissRegular, createElement(el_20, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_4) => {
            setIsOpen(false);
            setForm(regionToEdit);
        },
    })), (el_26 = Button, createElement(el_26, {
        icon: (el_24 = SaveRegular, createElement(el_24, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_5) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Region.UpdateRegion(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    if (res.fields[0].tag === 0) {
                        errorToast(setCtx, `updateRegion${regionToEdit.Id}NotFound`, "Kunne ikke oppdatere region", "Noe gikk galt", undefined);
                    }
                    else {
                        errorToast(setCtx, `updateRegion${regionToEdit.Id}Conflict`, "Kunne ikke oppdatere region", "Det finnes allerede en region med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    setRegions(map((r$0027) => {
                        if (r$0027.Id === r.Id) {
                            return r;
                        }
                        else {
                            return r$0027;
                        }
                    }, regions));
                    successToast(setCtx, `updateRegion${r.Id}Success`, "Suksess", `${r.Name} ble oppdatert`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: isNullOrWhiteSpace(form.Name),
        children: "Lagre endringer",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (name_2 = DialogBody, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_42)),
    })))), (name_4 = DialogSurface, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_44)),
    })))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function DeleteRegionDialog(deleteRegionDialogInputProps) {
    let elems_3, el_4, el_2, el, props_47, props_45, el_6, el_14, elems, el_20, elems_1, el_18, el_16, el_30, elems_2, name, name_2, elemsToUse;
    const setRegions = deleteRegionDialogInputProps.setRegions;
    const regions = deleteRegionDialogInputProps.regions;
    const regionToDelete = deleteRegionDialogInputProps.regionToDelete;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const el_32 = Dialog;
    return createElement(el_32, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_47 = singleton_1((props_45 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Er du sikker?",
    })), (el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = toList(delay(() => {
        let el_8;
        return append(singleton((el_8 = WarningFilled, createElement(el_8, {
            primaryFill: tokens.colorStatusWarningForeground1,
            fontSize: 48,
        }))), delay(() => {
            let el_10;
            return append(singleton((el_10 = Body1Strong, createElement(el_10, {
                children: `Er du sikker på at du vil slette ${regionToDelete.Name}? Det vil ikke være mulig å angre denne handlingen.`,
            }))), delay(() => {
                let el_12;
                return regionToDelete.Enabled ? singleton((el_12 = Body1, createElement(el_12, {
                    children: "Du kan alternativt sette regionen som inaktiv for å skjule den for brukere.",
                }))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "start"], (elems_1 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DismissRegular, createElement(el_16, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_1) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_30 = DialogActions, createElement(el_30, createObj(ofArray([["position", "end"], (elems_2 = toList(delay(() => {
        let el_24, el_22;
        return append(regionToDelete.Enabled ? singleton((el_24 = Button, createElement(el_24, {
            icon: (el_22 = PenDismissRegular, createElement(el_22, {})),
            iconPosition: "before",
            children: "Sett inaktiv",
            onClick: (_arg_2) => {
                setIsOpen(false);
                let pr_3;
                const pr_2 = startAsPromise(Region.UpdateRegion(new Region_1(regionToDelete.Id, regionToDelete.Name, false)));
                pr_3 = (pr_2.then((res_1) => {
                    if (res_1.tag === 1) {
                        errorToast(setCtx, `DisableRegion${regionToDelete.Id}Error`, "Kunne ikke oppdatere region", "Noe gikk galt", undefined);
                    }
                    else {
                        const r_1 = res_1.fields[0];
                        setRegions(map((r$0027) => {
                            if (r$0027.Id === r_1.Id) {
                                return r_1;
                            }
                            else {
                                return r$0027;
                            }
                        }, regions));
                        successToast(setCtx, `disableRegion${regionToDelete.Id}Success`, "Suksess", `${regionToDelete.Name} ble satt som inaktiv`);
                    }
                    return res_1;
                }));
                void (pr_3.catch((ex_1) => {
                    toastServerError(setCtx, ex_1);
                }));
            },
        }))) : empty(), delay(() => {
            let el_28, el_26;
            return singleton((el_28 = Button, createElement(el_28, {
                icon: (el_26 = DeleteRegular, createElement(el_26, {})),
                iconPosition: "before",
                appearance: "primary",
                children: "Slett",
                onClick: (_arg_3) => {
                    setIsOpen(false);
                    let pr_1;
                    const pr = startAsPromise(Region.DeleteRegion(regionToDelete.Id));
                    pr_1 = (pr.then((res) => {
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 0) {
                                errorToast(setCtx, `DeleteRegion${regionToDelete.Id}NotFound`, "Kunne ikke slette region", "Noe gikk galt", undefined);
                            }
                            else {
                                errorToast(setCtx, `DeleteRegion${regionToDelete.Id}WithWorkplaces`, "Kunne ikke slette region", "Regioner som har arbeidsplasser kan ikke slettes", undefined);
                            }
                        }
                        else {
                            setRegions(regions.filter((r) => (r.Id !== regionToDelete.Id)));
                            successToast(setCtx, `deleteRegion${regionToDelete.Id}Success`, "Suksess", `${regionToDelete.Name} ble slettet`);
                        }
                        return res;
                    }));
                    void (pr_1.catch((ex) => {
                        toastServerError(setCtx, ex);
                    }));
                },
            })));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_45)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_47)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

export function RegionsView() {
    let elems_6, elems_1, elems_5;
    const patternInput = reactApi.useState(undefined);
    const setRegions = patternInput[1];
    const regions = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Region.GetAllRegions());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                console.warn(some("Could not fetch regions"));
            }
            else {
                setRegions(res.fields[0]);
            }
            return res;
        }));
        void (pr_1.catch((exn) => {
            console.warn(some(`Could not fetch regions: ${exn.message}`));
        }));
    });
    const fullWidthCards = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Regioner",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Vis og administrer regioner",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let el_6, el_4;
            const matchValue = regions;
            if (matchValue != null) {
                const r_1 = matchValue;
                return singleton(createElement(AddRegionDialog, {
                    regions: r_1,
                    setRegions: (arg) => {
                        setRegions(arg);
                    },
                }));
            }
            else {
                return singleton((el_6 = Button, createElement(el_6, {
                    icon: (el_4 = AddRegular, createElement(el_4, {})),
                    iconPosition: "before",
                    children: "Legg til",
                    appearance: "primary",
                    disabled: true,
                })));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 1.5 + "rem",
        flexWrap: "wrap",
    }], (elems_5 = toList(delay(() => {
        let el_8;
        if (regions != null) {
            const r_2 = regions;
            return map((region) => {
                const el_20 = Card;
                return createElement(el_20, createObj(toList(delay(() => append(singleton(["key", `${region.Id}`]), delay(() => append(fullWidthCards ? singleton(["style", {
                    width: 100 + "%",
                }]) : singleton(["style", {
                    minWidth: 275,
                }]), delay(() => {
                    let elems_4, el_18, el_10, elems_2, elems_3;
                    return singleton((elems_4 = [(el_18 = CardHeader, createElement(el_18, {
                        header: (el_10 = Text$, createElement(el_10, {
                            weight: "semibold",
                            children: region.Name,
                        })),
                        description: createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 5 + "px ",
                        }], (elems_2 = toList(delay(() => {
                            let el_12;
                            return append(singleton((el_12 = Text$, createElement(el_12, {
                                children: "Aktiv",
                            }))), delay(() => {
                                let el_14, el_16;
                                return region.Enabled ? singleton((el_14 = CheckmarkFilled, createElement(el_14, {
                                    primaryFill: tokens.colorStatusSuccessForeground1,
                                }))) : singleton((el_16 = DismissFilled, createElement(el_16, {
                                    primaryFill: tokens.colorStatusDangerForeground1,
                                })));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
                        action: createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            gap: 5 + "px ",
                        }], (elems_3 = [createElement(EditRegionDialog, {
                            regionToEdit: region,
                            regions: r_2,
                            setRegions: (arg_1) => {
                                setRegions(arg_1);
                            },
                        }), createElement(DeleteRegionDialog, {
                            regionToDelete: region,
                            regions: r_2,
                            setRegions: (arg_2) => {
                                setRegions(arg_2);
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))),
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))]));
                }))))))));
            }, r_2);
        }
        else {
            return singleton((el_8 = Spinner, createElement(el_8, {})));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

//# sourceMappingURL=Regions.jsx.map
